class RatesTermsStageController {}

module.exports = RatesTermsStageController
